import {
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { CloseCircleOutline as CloseCircle, useToast } from '@aslanpay/portal-common-lib';
import PersonForm from 'app/components/UI/PersonForm/PersonForm';
import { PersonFormFields } from 'app/components/UI/PersonForm/PersonForm.types';
import useUpdateIndividual from 'app/hooks/useUpdateIndividual';

import { EditIndividualModalProps } from './EditIndividualModal.types';

function EditIndividualModal({ employee, isOpen, onClose, onSubmit }: EditIndividualModalProps) {
  const toast = useToast();

  const { mutate: updateIndividual, isLoading } = useUpdateIndividual({
    onSuccess: () => {
      toast({
        position: 'top-right',
        title: 'Changes saved successfully!',
        description: 'The person details have been updated.',
        status: 'success',
      });
      onSubmit();
      onClose();
    },
    onError: () => {
      toast({
        position: 'top-right',
        title: 'Error updating person',
        description: 'There was an error updating the person details. Please try again.',
        status: 'error',
      });
    },
  });

  const handleFormSubmit = (data: PersonFormFields) => {
    updateIndividual({
      ...employee,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      startDate: data.startDate,
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay>
        <ModalContent minW="610px" p="24px">
          <ModalHeader>
            <Flex align="center" justify="space-between">
              <Text textStyle="h4BoldCompact">Edit person details</Text>
              <IconButton
                variant="link"
                icon={<CloseCircle boxSize="30px" />}
                aria-label="Close modal"
                onClick={onClose}
              />
            </Flex>
          </ModalHeader>
          <ModalBody>
            <PersonForm
              onSubmit={handleFormSubmit}
              onCancel={onClose}
              mode="edit"
              initialValues={employee}
              isLoading={isLoading}
            />
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}

export default EditIndividualModal;
